// extracted by mini-css-extract-plugin
module.exports = {"verdict":"e_59","eyebrow":"e_69","rating":"e_79","plain":"e_89","count":"e_99","split":"e_-9","bar":"e_a-","sub":"e_b-","row":"e_c-"};